import Wireframe from './Wireframe';

export default Wireframe;



// WEBPACK FOOTER //
// ./src/components/Building/Main/LeftWireframe/index.js